export default __webpack_public_path__ + "static/media/deepsource_logo.9f0d0310.svg";